// extracted by mini-css-extract-plugin
module.exports = {"img--border":"style_img--border__SWFGv"};